import Vue from 'vue'
import Vuex from 'vuex'
import scorm from '@shared/utils/scormHandler'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    stepIndex: 0,
    steps: ['intro', 'cardGame', 'outro', 'saisieGta', 'endOutro'],
    absenceGameStep: 0,
    absenceGameFinished: false
  },
  getters: {
    currentStep (state) {
      return state.steps[state.stepIndex]
    },
    progress (state) {
      return state.stepIndex / (state.steps.length - 1) * 100
    },
    status (state, getters) {
      return getters.progress === 100 && state.absenceGameFinished ? 'passed' : 'incomplete'
    },
    cardGameStatus (state) {
      if (state.cardGameScore >= 9) {
        return 'success'
      } else if (state.cardGameScore >= 6) {
        return 'normal'
      } else {
        return 'fail'
      }
    }
  },
  mutations: {
    loadState (state, datas) {
      state.cardGameScore = datas.cardGameScore
      state.stepIndex = datas.stepIndex
      state.absenceGameStep = datas.absenceGameStep
      state.absenceGameFinished = datas.absenceGameFinished
    },
    nextStep (state) {
      state.stepIndex++
    },
    setCardGameScore (state, score) {
      state.cardGameScore = score
    },
    navigateTo (state, index) {
      state.stepIndex = index
    },
    setAbsenceGameStep (state, index) {
      state.absenceGameStep = index
    },
    setAbsenceGameFinished (state, status) {
      state.absenceGameFinished = status
    }
  },
  actions: {
    next ({ state, dispatch, commit }) {
      if (state.stepIndex === state.steps.length - 1) {
        dispatch('exit')
      } else {
        commit('nextStep')
      }
    },
    navigate ({ state, commit }, stepName) {
      commit('navigateTo', state.steps.indexOf(stepName))
    },
    init ({ dispatch }) {
      scorm.initLMSConnection()
      dispatch('load')
    },
    save ({ state, getters }) {
      scorm.setDatasToLMS({
        stepIndex: state.stepIndex,
        absenceGameStep: state.absenceGameStep,
        absenceGameFinished: state.absenceGameFinished,
        cardGameScore: state.cardGameScore
      })
      scorm.writeProgressToLMS(getters.progress, getters.status)
      try {
        scorm.commitToLMS()
      } catch (e) {
        if (process.env.NODE_ENV === 'production') {
          console.log('SCORM api error : ' + e)
        }
      }
    },
    load ({ commit }) {
      if (scorm.getDatasFromLMS()) {
        commit('loadState', scorm.getDatasFromLMS())
      }
    },
    exit ({ dispatch }) {
      dispatch('save')
      scorm.exitLMSConnection()
    }
  }
})
